<div class="row">
    <div class="col-6">
        <div class="primarySubTextLeft primarySubTextColor">
            {{customerName}}
        </div>
        <div class="secondarySubTextColor font_15">
            {{generalData[generalDetails.orderType]}}
        </div>
    </div>
    <div class="col-6 noPaddingRght">
        <div class="primarySubTextColor primarySubTextRight">
            {{generalData[generalDetails.insertDate]}}
        </div>
        <div class="primarySubTextColor primarySubTextRight dhl-font-ellips-enable"  isEllipsisActive>
            {{generalData[generalDetails.ponumber]}}
        </div>
    </div>

    <div class="overviewSeperator"></div>
</div>